import {combineReducers} from 'redux'

import theme from './themeReducer';
import selectedTheme from './selectedThemeReducer';
import workspaceId from './subscriptionIdReducer';
import workspaceIds from './subscriptionIdsReducer';
import locale from './localeReducer';
import locales from './localesReducer';
import year from './yearReducer';
import years from './yearsReducer';
import role from './roleReducer';
import roles from './rolesReducer';
import selectedYear from './selectedYearReducer';
import filtersData from './filtersReducer';
import businessIds from './sealIdsReducer';
import selectedBusinessIds from './selectedSealIdsReducer';
import sealIds from './sealIdsReducer';
import selectedSealIds from './selectedSealIdsReducer';
import team from './teamReducer';
import testContent from './testContentReducer';
import test from './testReducer';
import teamContent from './teamContentReducer';
import verum from './verumReducer';
import verumpkg from './verumpkgReducer';
import verumdbi from './verumdbiReducer';
import verumbcm from './verumbcmReducer';
import verumstorage from './verumstorageReducer';
import verummiddleware from './verummiddlewareReducer';
import verumContent from './verumContentReducer';
import verumpkgContent from './verumpkgContentReducer';
import verumdbiContent from './verumdbiContentReducer';
import verumstorageContent from './verumstorageContentReducer';
import selectedGridRow from './gridReducer';
import dfs from './dfsReducer';
import selectedDfs from './selectedDfsReducer';
import reclassify from './reclassifyReducer';
import reclassifyContent from './reclassifyContentReducer';

import sla from './slaReducer';
import slaContent from './slaContentReducer';
import appmodule from './moduleReducer';
import appmoduleContent from './moduleContentReducer';
import budget from './budgetReducer';
import budgetContent from './budgetContentReducer';
import budgetconsumption from './budgetconsumptionReducer';
import budgetconsumptionContent from './budgetconsumptionContentReducer';
import supplierconsumption from './supplierconsumptionReducer';
import supplierconsumptionContent from './supplierconsumptionContentReducer';
import totalbyaccount from './totalbyaccountReducer';
import totalbyaccountContent from './totalbyaccountContentReducer';
import auditlog from './auditlogReducer';
import auditlogContent from './auditlogContentReducer';
import budgetrequest from './budgetrequestReducer';
import budgetrequestContent from './budgetrequestContentReducer';
import budgetrequestextra from './budgetrequestextraReducer';
import budgetrequestextraContent from './budgetrequestextraContentReducer';
import glaccount from './glaccountReducer';
import glaccountContent from './glaccountContentReducer';
import ca from './caReducer';
import caContent from './caContentReducer';
import project from './projectReducer';
import projectreporting from './projectreportingReducer';
import projectContent from './projectContentReducer';
import projectreportingContent from './projectreportingContentReducer';
import budgetline from './budgetlineReducer';
import budgetlineContent from './budgetlineContentReducer';
import xrfbudgetpsfline from './xrfbudgetpsflineReducer';
import xrfbudgetpsflineContent from './xrfbudgetpsflineContentReducer';
import budgetlineForm from './budgetlineFormReducer';
import budgetlinedetail from './budgetlinedetailReducer';
import budgetlinedetailContent from './budgetlinedetailContentReducer';
import budgetlinedetailForm from './budgetlinedetailFormReducer';
import budgetrefs from './budgetrefsReducer';
import invoicerefs from './invoicerefsReducer';
import budgettypes from './budgettypesReducer';
import accounttypes from './accounttypesReducer';
import dftypes from './dftypesReducer';
import cadomains from './cadomainsReducer';
import caids from './caidsReducer';
import rbs from './rbsReducer';
import headofdivisions from './headofdivisionsReducer';
import servicetypes from './servicetypeReducer';
import rd1s from './rd1sReducer';
import rd2s from './rd2sReducer';
import projectleaders from './projectleadersReducer';
import flags from './flagsReducer';
import cdstatuss from './cdstatussReducer';
import selectedFeatures from './selectedFeaturesReducer';
import selectedBudgetrefs from './selectedBudgetrefsReducer';
import selectedBudgets from './selectedBudgetsReducer';
import selectedBudgettypes from './selectedBudgettypesReducer';
import selectedInvoicetypes from './selectedInvoicetypesReducer';
import selectedServicetypes from './selectedServicetypesReducer';
import selectedSuppliers from './selectedSuppliersReducer';
import selectedRd1s from './selectedRd1sReducer';
import selectedRd2s from './selectedRd2sReducer';
import selectedProjectleaders from './selectedProjectleadersReducer';
import selectedRole from './selectedRoleReducer';
import selectedFlags from './selectedFlagsReducer';
import selectedCdstatuss from './selectedCdstatussReducer';
import selectedAccounttypes from './selectedAccounttypesReducer';
import selectedDftypes from './selectedDftypesReducer';
import selectedCadomains from './selectedCadomainsReducer';
import selectedCaids from './selectedCaidsReducer';
import invoice from './invoiceReducer';
import invoiceContent from './invoiceContentReducer';
import invoiceline from './invoicelineReducer';
import invoicelineContent from './invoicelineContentReducer';
import invoicelinedetail from './invoicelinedetailReducer';
import invoicelinedetailContent from './invoicelinedetailContentReducer';
import fileloading from './fileloadingReducer';
import fileloadingContent from './fileloadingContentReducer';
import fileexport from './fileexportReducer';
import fileexportContent from './fileexportContentReducer';
import contract from './contractReducer';
import bcmContent from './bcmContentReducer';


import servicetype from './servicetypeReducer';
import servicetypeContent from './servicetypeContentReducer';
import seals from './sealsReducer';
import suppliers from './suppliersReducer';


import order from './orderReducer';
import orderContent from './orderContentReducer';
import psf from './psfReducer';
import psfContent from './psfContentReducer';
import psfline from './psflineReducer';

import application from './applicationReducer';
import applicationContent from './applicationContentReducer';

import approvalrequest from './approvalrequestReducer';
import approvalrequestContent from './approvalrequestContentReducer';
import moduleEntitlements from './module_entitlements_reducer';


import psflineContent from './psflineContentReducer';
import pdf from './pdfReducer';
import searchText from './filterReducer';
import integrationJob from './integrationJob';
import integrationJobContent from './integrationJobContent';

import supplier from './supplierReducer';
import supplierContent from './supplierContentReducer';

import business from './businessReducer';
import businessContent from './businessContentReducer';

import bcm from './bcmReducer';

import maxId from './formReducer';
import parameter from './parameterReducer';
import parameterContent from './parameterContentReducer';
import {
    isAuthReducer as isAuth,
    accountReducer as account,
    profileReducer as profile,
    apiTokenReducer as apiToken
} from './authReducer';

import {withReduxStateSync} from 'redux-state-sync'
import {RESET_STORE} from "../actions/resetStoreActions";
import initialState from "@/redux/reducers/_initialReducerState";


// Importing all reducers and combining them into a single root reducer
const appReducer = combineReducers({
    theme,
    selectedTheme,
    selectedFeatures,
    account,
    profile,
    apiToken,
    budget,
    budgetContent,
    budgetconsumption,
    budgetconsumptionContent,
    supplierconsumption,
    supplierconsumptionContent,
    reclassify,
    reclassifyContent,
    totalbyaccount,
    totalbyaccountContent,
    auditlog,
    auditlogContent,
    budgetline,
    budgetlineContent,
    xrfbudgetpsfline,
    xrfbudgetpsflineContent,
    budgetlineForm,
    budgetlinedetail,
    budgetlinedetailContent,
    budgetlinedetailForm,
    budgetrequest,
    budgetrequestContent,
    budgetrequestextra,
    budgetrequestextraContent,
    glaccount,
    glaccountContent,
    ca,
    caContent,
    project,
    projectContent,
    projectreporting,
    projectreportingContent,
    invoice,
    invoiceContent,
    invoiceline,
    invoicelineContent,
    invoicelinedetail,
    invoicelinedetailContent,
    fileloading,
    fileloadingContent,
    fileexport,
    fileexportContent,
    contract,
    order,
    orderContent,
    psf,
    psfContent,
    psfline,
    psflineContent,
    parameter,
    parameterContent,
    workspaceId,
    workspaceIds,
    locale,
    locales,
    year,
    role,
    roles,
    selectedYear,
    suppliers,
    supplier,
    supplierContent,
    budgetrefs,
    invoicerefs,
    selectedBudgets,
    selectedBudgetrefs,
    selectedBudgettypes,
    selectedInvoicetypes,
    budgettypes,
    accounttypes,
    dftypes,
    cadomains,
    caids,
    rbs,
    years,
    servicetypes,
    rd1s,
    rd2s,
    projectleaders,
    flags,
    cdstatuss,
    headofdivisions,
    selectedSuppliers,
    selectedServicetypes,
    selectedRd1s,
    selectedRd2s,
    selectedProjectleaders,
    selectedRole,
    selectedFlags,
    selectedCdstatuss,
    selectedAccounttypes,
    selectedDftypes,
    selectedCadomains,
    selectedCaids,
    filtersData,
    searchText,
    test,
    testContent,
    team,
    teamContent,
    pdf,
    integrationJob,
    integrationJobContent,
    verum,
    verumpkg,
    verumdbi,
    verumbcm,
    verumstorage,
    verummiddleware,
    verumContent,
    verumpkgContent,
    verumdbiContent,
    verumstorageContent,
    dfs,
    selectedDfs,
    sla,
    slaContent,
    module: appmodule,
    moduleContent: appmoduleContent,
    application,
    applicationContent,
    bcm,
    bcmContent,
    business,
    businessContent,
    selectedGridRow,
    maxId,
    isAuth,
    approvalrequest,
    approvalrequestContent,
    moduleEntitlements
})



const rootReducer = (state: any, action: any) => {

    if (action.type == RESET_STORE) {
        const newState = { ...initialState };

        // Preserve only TRUE user-level UI preferences across a store reset.
        // Everything else reset to its initial default — in particular the
        // previously-preserved tenant-scoped slices (workspaceId, workspaceIds,
        // selectedworkspaceId, selectedFeatures, years, selectedYear) were a
        // leak: they held the PREVIOUS tenant's selection after a tenant
        // switch, corrupting the new tenant's session. Theme is a user visual
        // preference (dark/light) and is not tenant-scoped, so it survives.
        newState.theme = state.theme;
        newState.selectedTheme = state.selectedTheme;

        return appReducer(newState, action);
    }
    return appReducer(state, action);
};


export default withReduxStateSync(rootReducer);
